import React, { useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  FormControl,
  MenuItem,
  Select,
  TextField,
  styled,
  Paper,
  Stack,
  Divider,
  Typography,
  Container,
  ListItem,
  ListItemButton,
  ListItemText,
  List,
  CircularProgress,
  alpha,
  Card,
  CardContent,
  Chip,
  Avatar,
  useTheme,
  Grid,
} from "@mui/material";
import AuthServices from "../../apis/AuthServices";
// import { Controller, useForm } from "react-hook-form";
import {
  LocationOn,
  Schedule,
  Train,
  AccessTime,
  Speed,
  Update,
  CalendarToday,
  DirectionsRailwayFilled,
} from "@mui/icons-material";
import { socketConfig } from "../../config/axios/socket";
import {
  getDateMonth,
  getEstArrivalTime,
  getTrainKmlUrl,
  getTrainNextStation,
  getTrainNextStations,
  getTrainStation,
  timeConvert,
} from "../../utils";
import Header from "./Header";
import Images from "../../assests";
import SimpleDialog from "../../components/Dialog";
import moment from "moment";
import { ErrorToaster } from "../../components/toaster/Toaster";
import Colors from "../../assests/style/Colors";
import { getLastUpdate } from "../../utils/utils2";

var timer;
let socket = null;
let selectedRideID = null;
let isDefaultCenter = false;

const TimelineContainer = styled(Box)(({ theme }) => ({
  position: "relative",
  padding: theme.spacing(1, 0, 2, 0),
}));

const StatusCard = styled(Card)(({ theme }) => ({
  background: `linear-gradient(135deg, ${
    theme.palette.background.paper
  } 0%, ${alpha(theme.palette.primary.main, 0.02)} 100%)`,
  borderRadius: theme.spacing(2),
  boxShadow: `0 8px 32px ${alpha(theme.palette.common.black, 0.08)}`,
  border: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  "&:hover": {
    transform: "translateY(-2px)",
    boxShadow: `0 12px 40px ${alpha(theme.palette.common.black, 0.12)}`,
  },
}));

const StationCard = styled(StatusCard)(({ theme, isFirst }) => ({
  position: "relative",
  marginBottom: theme.spacing(2.5),
  // marginLeft: theme.spacing(5),
  overflow: "visible",
}));

const InfoRow = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: theme.spacing(1.5, 0),
  borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
  "&:last-child": {
    borderBottom: "none",
    paddingBottom: 0,
  },
}));

const InfoLabel = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(1.5),
  minWidth: "140px",
}));

const InfoValue = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.primary,
  fontSize: "0.95rem",
}));

const LastUpdateCard = styled(StatusCard)(({ theme }) => ({
  marginTop: theme.spacing(3),
  background: `linear-gradient(135deg, ${alpha(
    theme.palette.success.main,
    0.05
  )} 0%, ${alpha(theme.palette.success.main, 0.02)} 100%)`,
  border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`,
}));

const BlinkingText = styled(Typography)(({ theme }) => ({
  "@keyframes blink": {
    "0%, 50%": { opacity: 1 },
    "51%, 100%": { opacity: 0.6 },
  },
  animation: "blink 2s infinite",
  fontWeight: 700,
  color: theme.palette.success.main,
}));
const ProfessionalContainer = styled(Container)(({ theme }) => ({
  background: `linear-gradient(135deg, ${alpha(
    theme.palette.primary.main,
    0.02
  )} 0%, ${alpha(theme.palette.secondary.main, 0.02)} 100%)`,
  minHeight: "100vh",
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
}));

const EmptyStateContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "400px",
  gap: theme.spacing(2),
  color: theme.palette.text.secondary,
}));
const TrainTrackingDropdown = () => {
  const [allTrains, setAllTrains] = useState("All Trains Live Tracking");
  const [selectedTrain, setSelectedTrain] = useState(null);
  const [trains, setTrains] = useState([]);
  const [stations, setStations] = useState([]);
  const [kmlUrl, setKmlUrl] = useState(
    "https://smartfuture.ae/kml/All-Trains.kml"
  );
  
  const [trainDetail, setTrainDetail] = useState("");
  const [trainMakers, setTrainMakers] = useState([]);
  const [trainStations, setTrainStations] = useState([]);
  const [trainPosition, setTrainPosition] = useState("all");
  const [nextStationId, setNextStationId] = useState();
  const [trainDateList, setTrainDateList] = useState([]);
  const [storeTrainData, setStoreTrainData] = useState();
  const [isTrain, setIsTrain] = useState(true);
  const [isShowStations, setIsShowStations] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [allLocomotive, setAllLocomotive] = useState([]);
  const [loading, setLoading] = useState(false);
  const [stationsLoading, setStationsLoading] = useState(false);
  const theme = useTheme();

  const activeTrains = trains.filter((trains) => trains.IsLive !== false);

  console.log(activeTrains, "activeTrains");
  const handleClose = (id) => {
    try {
      clearTimeout(timer);
      let obj = storeTrainData;
      // obj.TrainId = id;
      getTrainStatus(obj, "train-status", id);
      setOpenDialog(false);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getTrainStationsByTrainId = async (data) => {
    try {
      setStationsLoading(true);
      const { Response } = await AuthServices.getTrainsById(data?.TrainId);
      setTrainStations(Response);
      setStationsLoading(false);
    } catch (error) {
      //   ErrorToaster(error)
    }
  };
  const getTrainStatus = (data, event, id) => {
    try {
      isDefaultCenter = false;
      selectedRideID = id;
      let trainNumbers;
      if (socket?.disconnect) {
        socket.off("train-status", (e) => null);
        socket.off("all-dtrains", (e) => null);

        clearTimeout(timer);
      }

      trainNumbers = [data?.TrainNumber];

      socket = socketConfig();
      let isSocketConnected;
      const trainNumber = {
        trainId: trainNumbers.map((item) => item + "9900"),
        "track-train": encodeURI("tr@ckO||"),
      };
      socket.on("connect", () => {
        socket.emit(event, trainNumber);
        isSocketConnected = true;
      });

      socket.on("disconnect", () => {
        isSocketConnected = false;
      });

      socket.on("connect_error", (err) => {
        setTimeout(() => {
          socket.connect();
        }, 1000);
      });

      if (isSocketConnected == false) {
        socket.connect();
      }

      socket.on(event, (obj) => {
        let arr = [];
        if (obj === undefined || obj === null || JSON.stringify(obj) === "{}") {
          setTrainStations([]);

          ErrorToaster("Currently this train is not live.");
          return;
        } else {
          let rideID;
          let objDetail = [];
          let objKeys = [];
          let objLength = Object.keys(obj).length;
          objDetail.push(obj);
          let innerObjDetail = [];
          let innerObjLength;
          let trainName;
          let trainId;

          if (event === "all-dtrains") {
            for (let i = 0; i < objLength; i++) {
              rideID = objDetail.flatMap((x) => Object.keys(x))[i];
              innerObjLength = Object.keys(obj[rideID]).length;
              innerObjDetail.push(obj[rideID]);
              if (innerObjLength > 0) {
                // *Fetch Train Name from All Trains Array
                if (isTrain) {
                  for (let j = 0; j < trains.length; j++) {
                    // *If rideId is include in UP/DOWN TraindIDArray
                    let newRideId = rideID.replace("9900", "");
                    if (trainNumbers.includes(+newRideId)) {
                      if (+newRideId === trains[j]["TrainNumber"]) {
                        trainName = trains[j]["TrainName"];
                        trainId = trains[j]["TrainId"];
                        // *Get Key Wise Value From Train Objects
                        for (let k = 0; k < innerObjLength; k++) {
                          let key = innerObjDetail.flatMap((x) =>
                            Object.keys(x)
                          )[k];
                          let lat = +obj[rideID][key]["lat"];
                          let lng = +obj[rideID][key]["lon"];
                          let lastUpdate = +obj[rideID][key]["last_updated"];
                          let speed = +obj[rideID][key]["sp"];
                          let lateBy = +obj[rideID][key]["late_by"];
                          let nextStationID = +obj[rideID][key]["next_station"];
                          let prevStationID = +obj[rideID][key]["prev_station"];
                          let nextStop = obj[rideID][key]["next_stop"];
                          let trainIcon = obj[rideID][key]["icon"];
                          let isFlagged = obj[rideID][key]["isFlagged"];
                          arr.push({
                            // trainIcon: trainPosition === 'up' ? Images?.upTrain : Images?.dnTrain,
                            rideId: rideID,
                            trainIcon: trainIcon,
                            latitude: lat,
                            longitude: lng,
                            lastUpdate: lastUpdate,
                            speed: speed,
                            TrainName: trainName,
                            TrainId: trainId,
                            delay: lateBy,
                            nextStationId: nextStationID,
                            prevStationId: prevStationID,
                            nextStop: nextStop,
                            depDate: key,
                            isFlagged: isFlagged,
                          });
                        }
                      }
                    }
                  }
                } else {
                  for (let j = 0; j < allLocomotive.length; j++) {
                    // *If rideId is include in UP/DOWN TraindIDArray
                    if (trainNumbers.includes(+rideID)) {
                      if (+rideID === allLocomotive[j]["TrainNumber"]) {
                        trainName = allLocomotive[j]["LocomotiveNumber"];
                        // *Get Key Wise Value From Train Objects
                        for (let k = 0; k < innerObjLength; k++) {
                          let key = innerObjDetail.flatMap((x) =>
                            Object.keys(x)
                          )[k];
                          let lat = +obj[rideID][key]["lat"];
                          let lng = +obj[rideID][key]["lon"];
                          let lastUpdate = +obj[rideID][key]["last_updated"];
                          let speed = +obj[rideID][key]["sp"];
                          let lateBy = +obj[rideID][key]["late_by"];
                          let nextStationID = +obj[rideID][key]["next_st"];
                          arr.push({
                            trainIcon: Images.logo,
                            latitude: lat,
                            longitude: lng,
                            lastUpdate: lastUpdate,
                            speed: speed,
                            LocomotiveNumber: trainName,
                            delay: lateBy,
                            nextStationId: nextStationID,
                            depDate: key,
                          });
                        }
                      }
                    }
                  }
                }
                innerObjDetail = [];
              }
            }
            setTrainMakers(arr);
          } else {
            if (objLength > 1) {
              if (isTrain) {
                if (selectedRideID === null) {
                  setOpenDialog(true);
                  setStoreTrainData(data);
                  // console.log(data , 'elsw')
                  for (let i = 0; i < objLength; i++) {
                    rideID = objDetail.flatMap((x) => Object.keys(x))[i];
                    objKeys.push({
                      rideID: rideID,
                      departureDate: getDateMonth(rideID),
                      trainID: data.TrainId,
                    });
                  }
                  setTrainDateList(objKeys);
                  // setOpenDialog(false);
                } else {
                  updateTrainStatus(data, obj, selectedRideID);
                  // console.log(data,'---data')
                }
              } else {
                for (let i = 0; i < objLength; i++) {
                  rideID = objDetail.flatMap((x) => Object.keys(x))[i];
                  if (rideID == data?.TrainRideId) {
                    updateTrainStatus(data, obj, rideID);
                    // console.log(data ,"data332")
                  }
                }
              }
            } else {
              // rideID = objDetail.flatMap(x => Object.keys(x))[0];
              rideID = Object.keys(obj)[0];
              // console.log(data ,"data339")

              updateTrainStatus(data, obj, rideID);
            }
          }
          timer = setTimeout(() => {
            socket.emit(event, trainNumber);
          }, 10000);
        }
      });
    } catch (e) {
      ErrorToaster("🚀 ~ file: index.js:304 ~ getTrainStatus ~ e:", e);
    }
  };
  const getAllTrains = async (position) => {
    setLoading(true);
    try {
      isDefaultCenter = false;
      setIsTrain(true);
      const upTrains = [];
      const downTrains = [];
      const { Response } = await AuthServices.getTrains();
      setTrainStations([]);
      setTrainMakers([]);
      if (position === "all") {
        setTrains(Response);
        return;
      } else {
        Response.forEach((element) => {
          if (element.IsUp) {
            upTrains.push(element);
          } else {
            downTrains.push(element);
          }
        });
        if (position === "up") {
          setTrains(upTrains);
        } else {
          setTrains(downTrains);
        }
      }
    } catch (error) {
      //   ErrorToaster(error)
    } finally {
      setLoading(false);
    }
  };
  // console.log(trainDetail ,"rea")
  const updateTrainStatus = (data, trainObj, rideID) => {
    // console.log(selectedTrain ,"datagtrgtrg")
    // console.log(data ,"data")
    try {
      let spreadData = data;
      selectedRideID = rideID;
      spreadData.depDate = rideID;
      spreadData.latitude = parseFloat(trainObj[rideID]["lat"]);
      spreadData.longitude = parseFloat(trainObj[rideID]["lon"]);
      spreadData.lastUpdate = trainObj[rideID]["last_updated"];
      spreadData.delay = trainObj[rideID]["late_by"];
      spreadData.speed = trainObj[rideID]["sp"];
      spreadData.nextStationId = +trainObj[rideID]["next_station"];
      spreadData.prevStationId = +trainObj[rideID]["prev_station"];
      spreadData.nextStop = trainObj[rideID]["next_stop"];
      //   spreadData.trainIcon = data?.IsUp ? Images.upTrain : Images.dnTrain
      spreadData.isFlagged = trainObj[rideID]["isFlagged"];

      let nextStationID = +trainObj[rideID]["next_station"];
      (async () => {
        const { Response } = await AuthServices.getTrainsById(data?.TrainId);
        const filter = Response?.find(
          (e) => e.StationDetailsId === nextStationID
        );
        setNextStationId(filter?.OrderNumber);
      })();
      setTrainDetail(spreadData);
      if (isDefaultCenter === false) {
        isDefaultCenter = true;
      }
      setTrainMakers([spreadData]);
    } catch (e) {
      // console.log("🚀 ~ file: index.js:335 ~ updateTrainStatus ~ e:", e);
    }
  };
  const getAllLocomotive = async () => {
    setLoading(true);
    try {
      const { Response } = await AuthServices.getAllLocomotive();
      setAllLocomotive(Response);
      setIsTrain(false);
      setTrainMakers([]);
      setTrainStations([]);
    } catch (error) {
      //   ErrorToaster(error)
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllTrains("all");
  }, []);

  // useEffect(() => {
  //   getTrainStatus("", "all-dtrains", null);
  // }, [trains, allLocomotive]);

  return (
    <>
      <Container>
        <SimpleDialog
          open={openDialog}
          title={"Select Train Start Date"}
          onClose={() => setOpenDialog(false)}
        >
          <List>
            {trainDateList.map((date, index) => (
              <ListItem key={index} disablePadding>
                <ListItemButton onClick={() => handleClose(date?.rideID)}>
                  <ListItemText primary={date?.departureDate} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
        </SimpleDialog>

        <Box
          sx={{ position: "absolute", left: 0, top: 0, width: 1, zIndex: 5 }}
        >
          <Header
            loading={loading}
            isTrain={isTrain}
            trains={trains}
            locomotive={allLocomotive}
            getTrains={(position) => {
              getAllTrains(position);
              setTrainPosition(position);
            }}
            getTrainStatus={(data, socketEvent) => {
              getTrainStationsByTrainId(data);
              getTrainStatus(data, socketEvent, null);
              setIsShowStations(true);
            }}
            getAllLocomotive={() => getAllLocomotive()}
            setSelectedTrain={(data) => setSelectedTrain(data)}
            selectedTrain={selectedTrain}
          />
        </Box>
        <Box sx={{ mt: 30 }}>
          {stationsLoading == true ? (
            <Box sx={{ mt: 32, display: "flex", justifyContent: "center" }}>
              <CircularProgress sx={{ color: "#40fd41" }} />
            </Box>
          ) : !openDialog &&
            getTrainNextStations(trainStations, trainDetail?.prevStationId)
              ?.length > 0 ? (
            <>
              <LastUpdateCard>
                <CardContent sx={{ py: 2 }}>
                  <Stack spacing={2}>
                    {/* Last Update Row */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Avatar
                        sx={{
                          bgcolor: alpha(theme.palette.success.main, 0.1),
                          color: "success.main",
                        }}
                      >
                        <Update />
                      </Avatar>
                      <Box sx={{ flex: 1 }}>
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          gutterBottom
                        >
                          Last Update
                        </Typography>
                        <Typography sx={{ color: Colors.primary }} variant="h6">
                          {getLastUpdate(trainDetail?.lastUpdate)}
                        </Typography>
                      </Box>
                      <Chip
                        label="LIVE"
                        color="success"
                        size="small"
                        sx={{
                          fontWeight: 700,
                          animation: "pulse 2s infinite",
                          "@keyframes pulse": {
                            "0%": { opacity: 1 },
                            "50%": { opacity: 0.7 },
                            "100%": { opacity: 1 },
                          },
                        }}
                      />
                    </Box>

                    {/* Departure Date Row */}
                    <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                      <Avatar
                        sx={{
                          bgcolor: alpha(theme.palette.primary.main, 0.1),
                          color: "primary.main",
                        }}
                      >
                        <CalendarToday />
                      </Avatar>

                      <Box>
                        <Typography
                          variant="subtitle2"
                          color="text.secondary"
                          gutterBottom
                        >
                          Departure Date
                        </Typography>
                        <Typography sx={{ color: Colors.primary }} variant="h6">
                          {getDateMonth(trainDetail?.depDate)}
                        </Typography>
                      </Box>
                    </Box>
                  </Stack>
                </CardContent>
              </LastUpdateCard>

              <TimelineContainer>
                {getTrainNextStations(
                  trainStations,
                  trainDetail?.prevStationId
                ).map((station, index) => (
                  // console.log(station)
                  <StationCard
                    key={station.StationDetailsId}
                    isFirst={index === 0}
                    elevation={0}
                  >
                    <CardContent
                      sx={{
                        p: 3,
                        border: "3px solid #539356",
                        borderRadius: "20px",
                      }}
                    >
                      <Box
                        sx={{
                          mb: 2,
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Typography variant="h6" fontWeight={700} gutterBottom>
                          {station?.StationName}
                        </Typography>
                        {index === 0 && (
                          <Chip
                            label="Next Station"
                            color="primary"
                            size="small"
                            sx={{ fontWeight: 600 }}
                          />
                        )}
                      </Box>

                      <Stack spacing={0}>
                        <InfoRow>
                          <InfoLabel>
                            <Schedule
                              sx={{ color: "success.main", fontSize: 20 }}
                            />
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              fontWeight={500}
                            >
                              Scheduled Arrival
                            </Typography>
                          </InfoLabel>
                          <InfoValue>
                            {moment(
                              getEstArrivalTime(
                                trainStations,
                                trainDetail?.nextStationId,
                                trainDetail?.delay
                              ).find(
                                (item) =>
                                  item?.StationDetailsId ===
                                  station.StationDetailsId
                              )?.ArrivalTime,
                              "HH:mm"
                            ).format("hh:mm a")}
                          </InfoValue>
                        </InfoRow>

                        <InfoRow>
                          <InfoLabel>
                            <Train
                              sx={{ color: "primary.main", fontSize: 20 }}
                            />
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              fontWeight={500}
                            >
                              Estimated Arrival
                            </Typography>
                          </InfoLabel>
                          <InfoValue>
                            {
                              getEstArrivalTime(
                                trainStations,
                                trainDetail?.nextStationId,
                                trainDetail?.delay
                              ).find(
                                (item) =>
                                  item?.StationDetailsId ===
                                  station.StationDetailsId
                              )?.EstArrivalTime
                            }
                          </InfoValue>
                        </InfoRow>

                        <InfoRow>
                          <InfoLabel>
                            <AccessTime
                              sx={{ color: "warning.main", fontSize: 20 }}
                            />
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              fontWeight={500}
                            >
                              Delay
                            </Typography>
                          </InfoLabel>
                          <InfoValue
                            sx={{
                              color:
                                trainDetail?.delay > 0
                                  ? "warning.main"
                                  : "success.main",
                            }}
                          >
                            {timeConvert(trainDetail?.delay)}
                          </InfoValue>
                        </InfoRow>

                        {index === 0 && (
                          <InfoRow>
                            <InfoLabel>
                              <Speed
                                sx={{ color: "info.main", fontSize: 20 }}
                              />
                              <Typography
                                variant="body2"
                                color="text.secondary"
                                fontWeight={500}
                              >
                                Current Speed
                              </Typography>
                            </InfoLabel>
                            <InfoValue sx={{ color: "info.main" }}>
                              {trainDetail?.speed} km/hr
                            </InfoValue>
                          </InfoRow>
                        )}
                      </Stack>
                    </CardContent>
                  </StationCard>
                ))}
              </TimelineContainer>
            </>
          ) : (
            <>
              {/* <ProfessionalContainer maxWidth="md"> */}
              <EmptyStateContainer>
                <Avatar
                  sx={{
                    width: 80,
                    height: 80,
                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                    color: theme.palette.primary.main,
                  }}
                >
                  <Train sx={{ fontSize: 40 }} />
                </Avatar>

                <Typography
                  variant="h5"
                  color="text.secondary"
                  fontWeight={600}
                >
                  No Live Train Selected
                </Typography>

                <Typography
                  variant="body1"
                  color="text.secondary"
                  textAlign="center"
                  sx={{ mb: 3 }}
                >
                  Choose your desired train from the list to proceed.
                </Typography>
                <Grid container spacing={2} justifyContent={"center"}>
                  {/* Active Trains */}
                  <Grid item xs={12} sm={12} md={3}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        p: 2,
                        borderRadius: 2,
                        border: `1px solid ${alpha(
                          theme.palette.success.main,
                          0.3
                        )}`,
                        backgroundColor: alpha(
                          theme.palette.success.main,
                          0.05
                        ),
                      }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: alpha(theme.palette.success.main, 0.1),
                          color: "success.main",
                        }}
                      >
                        <Train />
                      </Avatar>
                      <Box>
                        <Typography variant="subtitle1" fontWeight={600}>
                          Active Trains
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {activeTrains?.length || 0} train
                          {activeTrains?.length !== 1 ? "s" : ""} active
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>

                  {/* All Trains */}
                  <Grid item xs={12} sm={12} md={3}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        gap: 2,
                        p: 2,
                        borderRadius: 2,
                        border: `1px solid ${alpha(
                          theme.palette.primary.main,
                          0.3
                        )}`,
                        backgroundColor: alpha(
                          theme.palette.primary.main,
                          0.05
                        ),
                      }}
                    >
                      <Avatar
                        sx={{
                          bgcolor: alpha(theme.palette.primary.main, 0.1),
                          color: "primary.main",
                        }}
                      >
                        <DirectionsRailwayFilled />
                      </Avatar>
                      <Box>
                        <Typography variant="subtitle1" fontWeight={600}>
                          All Trains
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          {trains?.length || 0} train
                          {trains?.length !== 1 ? "s" : ""} available
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>
              </EmptyStateContainer>

              {/* </ProfessionalContainer> */}
            </>
          )}
        </Box>
      </Container>
    </>
  );
};

export default TrainTrackingDropdown;
